module.exports = __webpack_public_path__ + "static/media/community-intro--resized2.92ce5643.jpg";